import FolderChange from 'owa-service/lib/contract/FolderChange';
import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import SetFolderField from 'owa-service/lib/contract/SetFolderField';
import UpdateFolderResponse from 'owa-service/lib/contract/UpdateFolderResponse';
import calendarFolder from 'owa-service/lib/factory/calendarFolder';
import folderChange from 'owa-service/lib/factory/folderChange';
import folderId from 'owa-service/lib/factory/folderId';
import getCalendarSharingCalendars from '../data/selectors/getCalendarSharingCalendars';
import getCalendarSharingCurrentState from '../data/selectors/getCalendarSharingCurrentState';
import getCalendarSharingInitialState from '../data/selectors/getCalendarSharingInitialState';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import saveCalendarSharingConfiguration from '../services/saveCalendarSharingConfiguration';
import setFolderField from 'owa-service/lib/factory/setFolderField';
import { trace } from 'owa-trace';
import updateChangeNotificationStatusInInitialState from '../data/mutators/updateChangeNotificationStatusInInitialState';

/**
 * 1. Gets current state from store selector.
 * 2. Gets list of shared calendars from store selector.
 * 3. Create a folderChange array of changes made to shared calendars.
 * 4. Call saveCalendarSharingConfiguration.
 */
export default async function saveSharedCalendarOption() {
    try {
        const currentState = getCalendarSharingCurrentState();
        const intialState = getCalendarSharingInitialState();
        const calendars = getCalendarSharingCalendars();
        let promisesArray: Promise<UpdateFolderResponse>[] = [];

        calendars.map(calendar => {
            let changes: FolderChange[] = [];
            const currentStatus = currentState[calendar.folderId];
            const intialStatus = intialState[calendar.folderId];
            if (currentStatus != intialStatus) {
                let updates: SetFolderField[] = [
                    setFolderField({
                        Path: propertyUri({ FieldURI: 'ChangeNotificationStatus' }),
                        Folder: calendarFolder({
                            ChangeNotificationStatus: currentStatus,
                        }),
                    }),
                ];
                changes.push(
                    folderChange({
                        FolderId: folderId({ Id: calendar.folderId }),
                        Updates: updates,
                    })
                );
                promisesArray.push(saveCalendarSharingConfiguration(changes));
            }
        });
        await Promise.all(promisesArray).then(results => {
            results.map(result => {
                if (result) {
                    let folderInfoResponseMessage = result.ResponseMessages
                        .Items[0] as FolderInfoResponseMessage;
                    let folderId = folderInfoResponseMessage.Folders[0].FolderId.Id;
                    updateChangeNotificationStatusInInitialState(folderId, currentState[folderId]);
                }
            });
        });
    } catch (e) {
        trace.warn(e.message || 'saveChangeNotificationStatusFlag failed');
    }
}
